export default __webpack_public_path__ + "static/media/manual24.e4728d7a.png";